module.exports = __webpack_public_path__ + "img/logo-white-only.1906f6f8.png";